import React from 'react';

import { Flex } from 'antd';

export const SuccessfullClosureApprovedToast = () => (
  <Flex vertical gap="0.5rem">
    <strong>Organization closed successfully.</strong>
    <strong>
      Anonymization will be applied in 3 months starting from today.
    </strong>
  </Flex>
);
